import type { TDatadogErrorLog } from 'utils/datadog/types'

import type { TUseNicheScopeReturn } from './niche-scope.types'

export const GET_SCOPE_TERRITORY_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/contexts/niche-scope',
  name: 'Get scope territory',
  message: 'Failed to fetch scoped territory for the promoted niche',
}

/** Returned by `useNicheScope` on unscoped routes (no `NicheScopeProvider`). */
export const NICHE_SCOPE_FALLBACK: TUseNicheScopeReturn = {
  categoryId: null,
  scopeId: null,
  territoryIds: null,
  scopeQuery: null,
  scopeName: null,
  isLoading: false,
}
